<template>
  <div class="content">
    <local-map v-if="agraConfiguration.mapTilesProvider"
               class="map-container fill-page"
               :filtered-boundaries="filteredBoundaries"
               :organisation-boundaries="organisationBoundaries" />
    <local-list ref="list"
                class="sidebar"
                :include-search-field="includeSearchField"
                :show-type-filter="showTypeFilter"
                :allowed-advanced-filters="allowedAdvancedFilters"
                @paginate="onPaginate">
      <template #sidebar-footer>
        <slot name="sidebar-footer" />
      </template>
    </local-list>
  </div>
</template>

<script>
import LocalMap from './local-map'
import LocalList from './local-list'
import { sharedMapPropsMixin } from './shared-map-props'
import { sharedLocalListPropsMixin } from './shared-local-list-props'
import { withLocalListMixin } from './with-local-list-mixin'

export default {
  components: { LocalList, LocalMap },

  mixins: [ sharedLocalListPropsMixin, sharedMapPropsMixin, withLocalListMixin ],

  props: {
    propFilters: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    // Cannot use the method from filterManagerMixin because it defines an urlFilterKeys property
    // that clashes with the fixed data attribute declared by withLocalListMixin
    propFiltersNotForUrl() {
      return this.propFilters.filter(f => !this.urlFilterKeys.includes(f.type))
    }
  },

  created() {
    this.$store.dispatch('getPoints')
  }
}
</script>

<style lang="scss" scoped>
@use "~common_styles/breakpoints" as breakpoints;

$sidebar-width: 350px;

@include breakpoints.screen-md-up {
  .content {
    display: flex;
    flex-direction: row-reverse;
  }

  .map-container {
    width: calc(100vw - #{$sidebar-width});
  }

  .sidebar {
    width: $sidebar-width;
  }

  ::v-deep(.footer) {
    & > .container {
      width: initial;
    }
  }
}

@include breakpoints.screen-mobile-only {
  .content {
    position: relative;
  }

  .map-container {
    height: 50vh;
  }
}
</style>
